import React from "react";

const MainLayout = ({ children }) => {
  return (
    <div className="bg-[#030405] mx-auto h-[100dvh] max-w-[576px] text-gray-200 relative">
      {children}
    </div>
  );
};

export default MainLayout;
